export default __webpack_public_path__ + "giveaway-locales/en-GB.0b0235090a464dca8d96827bfa81c1fa.json";